import { WebPlugin } from '@capacitor/core';
import { isError } from './utils';
export class DeviceAuthenticityWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.isValid = (value) => !isError(value);
        this.isError = isError;
    }
    async checkAuthenticity() {
        return { error: 'Not available on web' };
    }
    async isEmulator() {
        return { error: 'Not available on web' };
    }
    async isJailbroken() {
        return { error: 'Not available on web' };
    }
    async isRooted() {
        return { error: 'Not available on web' };
    }
    async isNotInstalledFromAllowedStore() {
        return { error: 'Not available on web' };
    }
    async getApkCertSignature() {
        return { error: 'Not available on web' };
    }
    async checkApkCertSignature() {
        return { error: 'Not available on web' };
    }
    async checkTags() {
        return { error: 'Not available on web' };
    }
    async checkPaths() {
        return { error: 'Not available on web' };
    }
    async checkExecutableFiles() {
        return { error: 'Not available on web' };
    }
    async hasThirdPartyAppStore() {
        return { error: 'Not available on web' };
    }
    async checkPrivateWrite() {
        return { error: 'Not available on web' };
    }
}
DeviceAuthenticityWeb.DEFAULT_ANDROID_ROOT_INDICATOR_TAGS = [
    'test-keys',
    'dev-keys',
    'userdebug',
    'engineering',
    'release-keys-debug',
    'custom',
    'rooted',
    'supersu',
    'magisk',
    'lineage',
    'unofficial',
];
DeviceAuthenticityWeb.DEFAULT_IOS_JAILBREAK_PATHS = [
    '/Applications/Cydia.app',
    '/Applications/Sileo.app',
    '/Applications/Zebra.app',
    '/Applications/Installer.app',
    '/Applications/Unc0ver.app',
    '/Applications/Checkra1n.app',
    '/Library/MobileSubstrate/MobileSubstrate.dylib',
    '/usr/sbin/sshd',
    '/usr/bin/sshd',
    '/usr/libexec/sftp-server',
    '/etc/apt',
    '/private/var/lib/apt/',
    '/private/var/mobile/Library/Cydia/',
    '/private/var/stash',
    '/private/var/db/stash',
    '/private/var/jailbreak',
    '/var/mobile/Library/SBSettings/Themes',
];
DeviceAuthenticityWeb.DEFAULT_ANDROID_ROOTED_PATHS = [
    '/system/app/Superuser.apk',
    '/sbin/su',
    '/system/bin/su',
    '/system/xbin/su',
    '/data/local/xbin/su',
    '/data/local/bin/su',
    '/system/sd/xbin/su',
    '/system/bin/failsafe/su',
    '/data/local/su',
    '/su/bin/su',
];
//# sourceMappingURL=web.js.map